const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const CopyTable = require("../../office/data/CopyTable");
const OpsParentSubChange = require("../vault/OpsParentSubChange");
const SubscriptionSummary = require("./SubscriptionSummary");

// Tiny wrapper class that renders SubscriptionSummary given an account prop.
// SubscriptionSummary takes more granular props for reusability; this
// component just does the computations needed to figure out those props.

module.exports = createReactClass({
	displayName: "SubscriptionSummaryAccount",

	propTypes: {
		account: PT.object.isRequired,

		// Forwarded to SubscriptionSummary
		showItemize: PT.bool,
		hideSubNames: PT.bool,
		onContinue: PT.func,
		showError: PT.bool,
		buttonText: PT.string,
		extraInfo: PT.node,
		hideFinalButtons: PT.bool,
		hideLink: PT.bool,
		tabIndex: PT.number,
		className: PT.string,
		prorateInfo: PT.object,
	},

	/* If necessary, render a message that keeps them from going to the next step */
	getBlockingMessage: function(account) {
		const blockingCopy = CopyTable.getChooseSubscriptionBlockingMessages();
		let blockingMessage = null;
		if (OpsParentSubChange.needsPlanType(account)) {
			blockingMessage = blockingCopy.needsPlanType;
			//Show a special combined message for plan type & display name
			if (OpsParentSubChange.needsDisplayName(account)) {
				blockingMessage = blockingCopy.needsPlanAndDisplayName;
			}
		} else if (OpsParentSubChange.needsDisplayName(account)) {
			// We don't NEED the display name to get prices
			blockingMessage = blockingCopy.needsDisplayName;
		} else if (OpsParentSubChange.needsBundleGrades(account)) {
			blockingMessage = blockingCopy.needsBundleGrades;
		}

		return blockingMessage;
	},

	render: function() {
		const {account} = this.props;
		const childProps = _.omit(this.props, "account");
		const currSub = OpsParentSubChange.getCurrentSubscription(account);
		const scs = account.subChangeState || {};
		if (scs.changeType === "upgrade") {
			childProps.upgradeInfo = {
				previousType: currSub.planType,
				newType: _.get(scs, "newPlanType"),
				displayName: OpsParentSubChange.getDisplayName(account),
			};
		}
		childProps.priceInfo = OpsParentSubChange.getPrices(account);
		childProps.priceLoadStatus = OpsParentSubChange.getPricesLoadStatus(
			account
		);
		childProps.needsShipping = OpsParentSubChange.needsShipping(account);
		childProps.changeWarningInfo = OpsParentSubChange.getChangeWarningInfo(
			account
		);
		childProps.couponExtraInfo = OpsParentSubChange.getCouponExtraInfo(account);
		childProps.blockingMessage = this.getBlockingMessage(account);
		childProps.couponInfo = {
			code: OpsParentSubChange.getCouponCode(account),
			lastCouponCode: OpsParentSubChange.getLastCouponCode(account),
		};
		childProps.needsBundleGrades = OpsParentSubChange.needsBundleGrades(
			account
		);
		childProps.needsPlanType = OpsParentSubChange.needsPlanType(account);
		return <SubscriptionSummary {...childProps} />;
	},
});
